import type { TokenData } from "../models/tokenDO.models";
import { TokenMetricNames } from "../models/tokenDO.models";
import type { TokenDataService } from "../services/tokenData.service";
import { buildTokenData, getMetricColor } from "../helpers/tokenData.helpers";

type TokenMetric = keyof TokenData;

export class TokenDataItem extends HTMLElement {
    constructor(private tokenDataService: TokenDataService = window.tbwServices.tokenDataService) {
        super();
        this.classList.add('token-data-item');
    }

    static get observedAttributes() {
        return ['data-token-slug', 'metric-name'];
    }

    connectedCallback() {
        void this.load();
    }

    attributeChangedCallback() {
        if (!this.isConnected) { return; }
        void this.load();
    }

    private async load() {
        try {
            const tokenSlug = this.getTokenSlug();
            const metric = this.getMetricName();
            const tokenData = await this.tokenDataService.getTokenData(tokenSlug);

            if (tokenData.length === 0) { throw new Error('No token data found'); }

            const formattedData = buildTokenData(tokenData[0]);
            this.render(formattedData, metric);
        } catch (error) {
            console.error(error);
        }
    }

    private render(tokenDataItem: TokenData, metric: TokenMetric) {
        const value = tokenDataItem[metric];
        if (value === null || value === undefined) { return; }

        this.innerHTML = '';
        const paragraph = document.createElement('p');
        paragraph.textContent = value;

        if (metric === 'percent_change_24h') {
            paragraph.style.color = getMetricColor(tokenDataItem, metric);
        }

        this.appendChild(paragraph);
    }

    private getTokenSlug() {
        const tokenSlug = this.getAttribute('data-token-slug');
        if (!tokenSlug) { throw new Error('Token slug not found'); }
        return tokenSlug;
    }

    private getMetricName(): TokenMetric {
        const metricName = this.getAttribute('metric-name');

        if (!metricName) {
            throw new Error('Metric name attribute not found');
        }

        if (!(metricName in TokenMetricNames)) {
            throw new Error(`Metric "${metricName}" is not supported`);
        }

        return metricName as TokenMetric;
    }
}

